import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { APP_CONFIG } from '../config/app-config';

import plTranslations from './locales/pl.json';
import enTranslations from './locales/en.json';

// Initialize i18n
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        pl: {
          translation: plTranslations,
        },
        en: {
          translation: enTranslations,
        },
      },
      lng: APP_CONFIG.DEFAULT_LOCALE,
      fallbackLng: APP_CONFIG.DEFAULT_LOCALE,
      supportedLngs: APP_CONFIG.SUPPORTED_LOCALES,
      defaultNS: 'translation',
      ns: ['translation'],
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage', 'navigator'],
        caches: ['localStorage'],
      },
      react: {
        useSuspense: false,
      },
      debug: false,
    });
}

export default i18n;
